import ActionType from './action-type'
import * as Actions from './actions'

export const setFilterState = (onlyUserCHR: boolean): Actions.setFilterState => ({
    type: ActionType.SET_FILTER_STATE,
    payload: onlyUserCHR,
})
